import React from "react";
import { ContainerPanel } from "@components/organisms/container-panel/container-panel";
import { SubHeader } from "@src/components/atoms/sub-header/sub-header";
import { SubTitle } from "@src/components/atoms/sub-title/sub-title";
import styles from "./dashboard-text-panel-content.module.scss";

interface DashboardPanelProps {
  title: string;
  nodeName: string;
  value: string;
  unit: string;
}

const cssClassName = "dashboard-text-panel-content";

export const DashboardTextPanelContent = ({
  title,
  nodeName,
  value,
  unit,
}: DashboardPanelProps) => {
  return (
    <div className={styles[cssClassName]}>
      <ContainerPanel>
        <SubHeader>
          <SubTitle text={title} />
        </SubHeader>
        <div className={styles[`${cssClassName}__text-wrapper`]}>
          <p className={styles[`${cssClassName}__small-text`]}>{nodeName}</p>
          <div>
            <span className={styles[`${cssClassName}__large-text`]}>
              {value}
            </span>
            <span className={styles[`${cssClassName}__medium-text`]}>
              {unit}
            </span>
          </div>
        </div>
      </ContainerPanel>
    </div>
  );
};
